document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("waitlist-form")) {
    class WaitlistForm extends HTMLElement {
      constructor() {
        super();
        this.delay = 3000;
        this.form = this.querySelector("form");
        this.selectVariants = this.querySelector("#variants");
        this.forms = document.querySelectorAll(".product-item form");
        this.formVariant = this.querySelector("#variants");
        this.accountId = this.querySelector("#bis_account_id").value;
      }

      toggleAlertMessage(success = false) {
        const message = this.querySelector(
          success ? ".custom-alert-success" : ".custom-alert-error"
        );
        if (!message) return;
        this.querySelector(".button-modal-submit").classList.add("hidden");
        message.classList.remove("hidden");
        setTimeout(() => {
          document.querySelector("#waitlist-modal").removeAttribute("open");
          this.querySelector(".button-modal-submit").classList.remove("hidden");
          message.classList.add("hidden");
        }, this.delay);
      }

      onSubmitHandler(event) {
        event.preventDefault();

        const formData = new FormData(event.target);
        let currentFormData = Object.fromEntries(formData);

        let payloadBIS = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: `${currentFormData.bis_email}`,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `${currentFormData.platform}:::$default:::${currentFormData.bis_variant_id}`,
                },
              },
            },
          },
        };

        this.postRequest(this.form.action, payloadBIS, this.accountId);
        if (typeof window.fbq === "function") {
          window.fbq("track", "AddToWishlist");
        } else {
          console.error("Facebook Pixel fbq function not found.");
        }
      }

      postRequest(action, payload, accountID) {
        if (!action || !payload || !accountID) return;

        const payloadObject = {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            revision: "2024-06-15",
            "Content-Type": "application/json",
          },
        };

        console.log("PAYLOAD -> ", payloadObject);

        fetch(`${action}?company_id=${accountID}`, payloadObject)
          .then((response) => {
            console.log("RESPONSE -> ", response);
            if (!response.ok) {
              this.toggleAlertMessage();
              throw new Error(response.statusText);
            }

            this.toggleAlertMessage(true);
          })
          .catch((err) =>
            console.error("Klaviyo waitlist form is not submitted", err)
          );
      }

      connectedCallback() {
        this.forms.forEach((form) => {
          const formNotifyMeButton = form.querySelector(".cb_BISModal_trigger");
          const productVariants = form.querySelectorAll(".variant--selector");
          formNotifyMeButton?.addEventListener("click", () => {
            this.formVariant.innerHTML = "";
            productVariants.forEach((variant) => {
              this.formVariant.appendChild(variant.cloneNode(true));
            });

            const waitlistProductId =
              this.form.querySelector("#bis_product_id");
            if (waitlistProductId) {
              waitlistProductId.value =
                form.querySelector("#bis_product_id").value;
            }
            const modalVariants =
            this.formVariant.querySelectorAll(".variant--selector");
            modalVariants.forEach((variant) => {
              variant.classList.remove("visually-hidden");
            });
          });
        });

        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      disconnectedCallback() {
        this.forms.forEach((form) => {
          form?.removeEventListener("submit", this.onSubmitHandler.bind(this));
        });
      }
    }

    customElements.define("waitlist-form", WaitlistForm);
  }
});
